<template>
    <el-dialog title="附件列表" :visible="showflag" :width="width" @close="closeDialog" :close-on-click-modal="false">
        <div class="noticeBox">
            <div class="fileDown" v-for="file in list" :key="'fi'+file.id">
                <el-image class="icon" :src="imgServer+'/static'+file.icon"></el-image>
                <div class="ftitleBox">
                    <div class="title">{{file.title}}</div>
                    <div class="ftitle" style="margin-top:4px">{{file.file_size}}</div>
                </div>
                <el-button type="primary" plain size="mini" class="downBtn1" @click="downFile(file.file_path)">下载</el-button>
                <el-button type="danger" plain size="mini" class="downBtn" @click="deleteFile(file.id)">删除</el-button>
            </div>
        </div>
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="toAddAnnex" size="medium">添 加</el-button>
            <el-button @click="closeDialog" size="medium">关 闭</el-button>
        </div>
        <AddAnnex
            width="600px"
            title="添加附件"
            :data_id="data_id"
            :isshow="addshow"
            @on-close="closeAddDialog"
            @on-save-ok="saveOk">
        </AddAnnex>
    </el-dialog>
</template>

<script>
import AddAnnex from "./annexadd.vue"
import { monthReportAnnexList, deleteMonthReportAnnex } from '@/api/annex'
import config from "@/config/index"

export default {
    name: 'monthReportAnnexList',
    components: {AddAnnex},
    props: {
        isshow: {
            type: Boolean,
            default() {
                return false;
            }
        },
        data_id: {
            type: Number,
            default() {
                return -1;
            }
        },
        width: {
            type: String,
            default() {
                return '800px';
            }
        }
    },
    watch: {
        isshow(newv, old) {
            this.showflag = newv;
            if (newv) {
                this.getAnnexList()
            }
        }
    },
    data() {
        return {
            showflag: false,
            enu_name: [],
            list: [],
            addshow: false,
            imgServer: config.imgServer,
        };
    },
    methods: {
        getAnnexList(){
            this.list = [];
            monthReportAnnexList(this.data_id).then(res=>{
                if(res.code ==1){
                    this.list = res.data
                }else{
                    this.$msg(res.msg)
                }
            })
        },
        closeDialog(){
            this.$emit("on-close")
        },
        toAddAnnex(){
            this.addshow = true
        },
        closeAddDialog(){
            this.addshow = false
        },
        saveOk(){
            this.addshow = false
            this.getAnnexList()
        },
        downFile(url){
            let cos_domain = localStorage.getItem("cos_domain")
            if(url.indexOf("#")>=0){
                url = url.replaceAll("#", "%23")
            }
            window.open(cos_domain+url)
        },
        deleteFile(id){
            this.$confirm('确定要删除该附件吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                deleteMonthReportAnnex(id).then(res=>{
                    if(res.code == 1){
                        this.$msgs(res.msg)
                        this.getAnnexList()
                    }else{
                        this.$msg(res.msg)
                    }
                })
            }).catch(() => { })
        },
    }
};
</script>

<style lang="less" scoped>
    .noticeBox {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;
        .fileDown {
            width: 100%;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: flex-start;
            font-size: 16px;
            color: #909399;
            margin-bottom: 20px;
            box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
            padding: 10px;
            box-sizing: border-box;
            border-radius: 6px;
            position: relative;
            .icon {
                width: 52px;
                height: 52px;
            }
            .ftitleBox {
                display: flex;
                flex-direction: column;
                align-items: flex-start;
                justify-content: flex-start;
                margin-left: 8px;
                .title{
                    color: #303133;
                    font-size: 14px;
                }
                .ftitle {
                    font-size: 12px;
                }
            }
            .downBtn {
                position: absolute;
                right: 20px;
            }
            .downBtn1 {
                position: absolute;
                right: 90px;
            }
        }
    }
</style>
